// src/features/game/components/GameDateSelector.tsx

import React from 'react';

import {
  ChevronLeft,
  ChevronRight,
} from 'lucide-react';

import {
  getTodayDate,
} from '../../../shared/utils/timeUtils';

interface GameDateSelectorProps {
  value: string;

  onChange: (
    date: string,
  ) => void;
}

const changeDate = (
  dateString: string,
  amount: number,
): string => {
  const date =
    new Date(
      `${dateString}T00:00:00`,
    );

  date.setDate(
    date.getDate() +
      amount,
  );

  const year =
    date.getFullYear();

  const month =
    String(
      date.getMonth() + 1,
    ).padStart(2, '0');

  const day =
    String(
      date.getDate(),
    ).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

const GameDateSelector:
  React.FC<
    GameDateSelectorProps
  > = ({
    value,
    onChange,
  }) => {
  return (
    <div>
      <label className="mb-1 block text-14-medium text-gray-700">
        날짜
      </label>

      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={() =>
            onChange(
              changeDate(
                value,
                -1,
              ),
            )
          }
          className="rounded-lg border border-gray-300 p-2 text-gray-600 hover:bg-gray-100"
        >
          <ChevronLeft
            size={18}
          />
        </button>

        <input
          type="date"
          value={value}
          onChange={(event) =>
            onChange(
              event.target.value,
            )
          }
          className="rounded-lg border border-gray-300 px-4 py-2 outline-none focus:border-main"
        />

        <button
          type="button"
          onClick={() =>
            onChange(
              changeDate(
                value,
                1,
              ),
            )
          }
          className="rounded-lg border border-gray-300 p-2 text-gray-600 hover:bg-gray-100"
        >
          <ChevronRight
            size={18}
          />
        </button>

        <button
          type="button"
          onClick={() =>
            onChange(
              getTodayDate(),
            )
          }
          className="rounded-lg px-3 py-2 text-main hover:bg-main/10"
        >
          오늘
        </button>
      </div>
    </div>
  );
};

export default GameDateSelector;